import { Action } from '@ngrx/store';
import { type } from '../../../util';
import {
  IPasswordPolicyViewModel,
  IRecruitNamesInfoViewModel
} from '../../../core/services/password-policy/interfaces';

export const ActionTypes = {
  FETCH_PASSWORD_POLICY: type('[Password Policy] fetch password rules'),
  UPDATE_PASSWORD_POLICY: type('[Password Policy] update password rules'),
  SET_MISC_PASSWORD_VALIDITY: type('[Password Policy] update misc password validity'),
  FETCH_RECRUIT_NAMES: type('[Password Policy] fetch recruit names'),
  UPDATE_RECRUIT_NAMES: type('[Password Policy] update recruit names'),
};

export class FetchPasswordPolicy implements Action {
  public type = ActionTypes.FETCH_PASSWORD_POLICY;

  constructor(public payload?: any) {}
}

export class UpdatePasswordPolicy implements Action {
    public type = ActionTypes.UPDATE_PASSWORD_POLICY;

    constructor(public payload: IPasswordPolicyViewModel) {}
}

export class SetMiscPasswordValidity implements Action {
    public type = ActionTypes.SET_MISC_PASSWORD_VALIDITY;

    constructor(public payload: boolean) {}
}

export class FetchRecruitNames implements Action {
  public type = ActionTypes.FETCH_RECRUIT_NAMES;

  constructor(public payload?: any) {}
}

export class UpdateRecruitNames implements Action {
  public type = ActionTypes.UPDATE_RECRUIT_NAMES;

  constructor(public payload: IRecruitNamesInfoViewModel) {}
}

export type TypeAction =
  FetchPasswordPolicy |
  UpdatePasswordPolicy |
  SetMiscPasswordValidity |
  FetchRecruitNames |
  UpdateRecruitNames;
